import { HelpIcon } from '@daily/shared/components/Icons/HelpIcon';
import { memo } from 'react';
import { useTranslation } from 'react-i18next';

import { useCustomIntegrations } from '../../hooks/useCustomIntegrations';

interface Props {
  id: string;
  style?: React.CSSProperties;
  size?: number;
}

export const AppIcon: React.FC<Props> = memo(({ id, size, style }) => {
  const { t } = useTranslation();
  const { mainIntegrations } = useCustomIntegrations();
  const app = mainIntegrations.find((i) => i.id === id);

  return app?.iconURL ? (
    <img
      alt={t('integrations.iconAltText', {
        label: app.label,
      })}
      src={app.iconURL}
      style={style}
      width={size}
    />
  ) : (
    <HelpIcon size={size} style={style} />
  );
});
AppIcon.displayName = 'AppIcon';
